import React, { useEffect } from 'react'
import { useMarketplace } from '../../hooks/useMarketplace'

import { imageJitURL } from '../../utils/imageJitURL'

import { showAppBannerVar } from '../SiteHeader/utils/reactiveVar'
import { useReactiveVar } from '@apollo/client'

import {
  AppBannerContainer,
  StyledButton,
  StyledCircleCrossSVG,
  TextAndLogoContainer,
  AppImage,
  AppText,
  AppLink,
  AppLinkText,
  ButtonAndLogoAndTextContainer,
} from './AppBannerStyles'

const ua = navigator.userAgent
const isIOS = /iPhone|iPad|iPod/i.test(ua)
const isAndroid = /Android/i.test(ua)

export const AppBanner = () => {
  const showBanner = useReactiveVar(showAppBannerVar)

  const { storeURLApple, storeURLGooglePlay, appText, faviconImage } =
    useMarketplace()

  const link = isIOS ? storeURLApple : storeURLGooglePlay

  useEffect(() => {
    const dismissed = localStorage.getItem('dismissedAppBanner') === 'true'
    if ((isIOS || isAndroid) && !dismissed && link) {
      showAppBannerVar(true)
    }
  }, [])

  const handleDismiss = () => {
    localStorage.setItem('dismissedAppBanner', 'true')

    showAppBannerVar(false)
  }

  if (!showBanner || !link) return null
  return (
    <AppBannerContainer>
      <ButtonAndLogoAndTextContainer>
        <StyledButton onClick={handleDismiss}>
          <StyledCircleCrossSVG
            id="close"
            title="Close button"
            dataTestId="drawer-header-close-button"
          />
        </StyledButton>
        <TextAndLogoContainer>
          {faviconImage && (
            <AppImage
              src={imageJitURL(faviconImage, {
                resize: {
                  width: 64,
                  height: 64,
                  fit: 'cover',
                },
              })}
              alt="App Icon"
            />
          )}
          <AppText>{appText}</AppText>
        </TextAndLogoContainer>
      </ButtonAndLogoAndTextContainer>
      <AppLink href={link}>
        <AppLinkText>Download</AppLinkText>
      </AppLink>
    </AppBannerContainer>
  )
}
